import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Image,
  Text
} from 'grommet'
import useWindowSize from '../../utils/WindowSize';
import { animated, useSpring } from "react-spring";
import ComponentVideo from "./Video";
import RenderRichText from '../../utils/RenderRichText';

const HeroSimple = (props) => {
  const { content, title } = props;
  //console.log(content)
  const [imageLoaded, setImageLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const heroTextWrapperRef = useRef(null); // Track reference to hero text wrapper
  const [heroTextHeight, setHeroTextHeight] = useState(0);

useEffect(() => {
  if (heroTextWrapperRef.current) {
    setHeroTextHeight(heroTextWrapperRef.current.offsetHeight);
  }
}, [content]); // Add dependencies as needed

  const listener = e => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", listener);
    return () => {
      window.removeEventListener("scroll", listener);
    };
  });

  const calcOpacity = () => {
    return 1 - (scrollY >= 300 ? '1' : scrollY / 300)
  }

  const calcScale = () => {
    return 1 - (scrollY / 2000)
  }

  const calcOffset = () => {
    return (scrollY / 2)
  }

  const moveIt = useSpring({
    opacity: calcOpacity(),
    transform: `translateY(${calcOffset()}px)`
  });

  // window size
  const size = useWindowSize();

  const hasImage = () => {
      return (content.fields.hasOwnProperty("image") && content.fields.image) || (content.fields.hasOwnProperty("parrallaxImage") && content.fields.parrallaxImage);
  }

  const hasVideo = () => {
      if (content.fields.hasOwnProperty("youtubeVideoId") && content.fields.youtubeVideoId ){
        return content.fields.youtubeVideoId;
      } else {
        return false;
      }
  }

  const renderVideo = () => {
    if (hasVideo()){
      return (
        <div className="hero-simple__video-wrapper">
          <ComponentVideo
            youtubeVideoId={content.fields.youtubeVideoId}
            posterImage={ hasImage() ? content.fields.image.fields.file.url : false }
            disableZoom={disableZoom()}
          />
        </div>
      )
    } else {
      return null;
    }
  }

  const disableZoom = () => {
    if (content.fields.hasOwnProperty("disableZoom")){
      return content.fields.disableZoom;
    } else {
      return false;
    }
  }

  const getZoomAnimationClass = () => {
    if (disableZoom()){
      return " ";
      //return " transitionFadeIn ";
    } else {
      return " transitionFadeInScale "
    }
  }

  const showTitle = () => {
    if (content.fields.hasOwnProperty("showTitle") && content.fields.showTitle){
      return (
        <h1 className="">{content.fields.title}</h1>
      )
    } else {
      return null;
    }
  }

  const showText = () => {
    if (content.fields.hasOwnProperty("text") && content.fields.text){
      return (
        <div className="heroText">
          <Text className="bigText">
            {RenderRichText(content.fields.text)}
          </Text>
        </div>
      )
    } else {
      return null;
    }
  }

  const handleImageLoaded = () => {
    setImageLoaded("true");
  }

  /**
   * Render the top image if present
   */
  const renderTopImage = () => {
    if (
      content.fields.hasOwnProperty("parrallaxImage")
      && content.fields.parrallaxImage
    ){
      // Parrallax images
      return (
        <div className="hero-simple__image-top">
          <animated.img
            style={moveIt}
            className="hero-simple__image-top__image"
            src={content.fields.parrallaxImage.fields.file.url}
            onLoad={handleImageLoaded.bind(this)}
          />
        </div>
      )
    } else {
      return null;
    }
  }

  /**
   * Render the bottom image iof present
   */
  const renderBottomImage = () => {
    if (
      content.fields.hasOwnProperty("image")
      && content.fields.image
    ){
      // Bottom image
      return (
        <img
          className="hero-simple__image-bottom__image"
          src={content.fields.image.fields.file.url}
          onLoad={handleImageLoaded.bind(this)}
        />
      )
    }
  }

  if (!hasImage() && !hasVideo() && title){
    return (
      <Box
        className="hero-simple hero-simple--title-only">
        <h1 className="transitionSlideUp">{title}</h1>
      </Box>
    )
  } else if (!hasImage() && !hasVideo()){
    return (
      <Box
        className="hero-simple hero-simple--title-only">
          <div 
            className="hero-simple__text-wrapper" 
            ref={heroTextWrapperRef} 
            style={{
            }}
          >
            {showTitle()}
            {showText()}
          </div> 
      </Box>
    )
  } else {
    return (
        <Box
          className="hero-simple"
        >
          {renderTopImage()}
          <div 
            className="hero-simple__text-wrapper" 
            ref={heroTextWrapperRef} 
            style={{
            }}
          >
            {showTitle()}
            {showText()}
          </div> 
          {renderBottomImage()}
          {renderVideo()}
        </Box>
    )
  }
}

export default HeroSimple;
